import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { STATUSES } from '__constants__'
import { Text } from '@qonsoll/react-design'
import { useSubfilterActions } from 'hooks'
import { useTranslations } from 'contexts/Translation'

const StatusFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslations()

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'status',
    operand: '==',
    type: 'rejectReasonStatus'
  })

  const { REJECT_REASON_STATUSES } = STATUSES

  const rejectReasonStatuses = Object.values(REJECT_REASON_STATUSES)?.map(
    (rejectReasonStatus) => ({
      value: rejectReasonStatus,
      name: rejectReasonStatus
    })
  )

  return (
    <details
      open={localStorage.getItem(`status-details-visibility`) === 'opened'}>
      <summary onClick={onToggleDetails}>{t('Status')}</summary>
      {rejectReasonStatuses?.map((status, index) => (
        <Checkbox
          key={`status-${index}`}
          checked={checkIsEnabled(status)}
          onChange={() => onChange(status)}>
          <Text wordBreak="break-all">
            {status?.name || t('Unnamed filter')}
          </Text>
        </Checkbox>
      ))}
    </details>
  )
}

StatusFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default StatusFilter
